import { module as BaseModule } from 'modujs';
import Swiper from 'swiper';
import {
  Autoplay,
  EffectFade,
  Pagination,
} from 'swiper/modules';
import gsap from 'gsap';
import SplitType from 'split-type';

//import { getImageLightness } from '../utils/image';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.previousIndex = null;
    this.carousel = this.$('carousel')[0];
    this.slides = this.$('slide');
    this.shortcuts = this.$('shortcuts')[0];
  }

  loadSlider() {
    this.swiper = new Swiper(this.carousel, {
      modules: [ Autoplay, EffectFade, Pagination ],
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      runCallbacksOnInit: true,
      pagination: {
        el: '.swiper-pagination',
      },
      on: {
        afterInit: (s) => {
          const title = s.slides[ s.activeIndex ].querySelectorAll('.c-hero_slide_title .o-word');

          gsap.to(title, {
            opacity: 1,
            y: '0%',
            duration: 0.8,
            delay: 1.0,
            stagger: { each: 0.1 },
            ease: 'expo.out'
          });
        },
        realIndexChange: (s) => {
          const title = s.slides[ s.activeIndex ].querySelectorAll('.c-hero_slide_title .o-word');

          gsap.set(title, {
            opacity: 0,
            y: '100%',
          });
        },
        slideChangeTransitionEnd: (s) => {
          const title = s.slides[ s.activeIndex ].querySelectorAll('.c-hero_slide_title .o-word');

          gsap.to(title, {
            opacity: 1,
            y: '0%',
            duration: 0.8,
            delay: 0,
            stagger: { each: 0.1 },
            ease: 'power3.out'
          });
        }
      },
    });
  }

  setupSlides() {
    this.slides.forEach( ( el,i ) => {
      if ( 'undefined' !== typeof el.dataset.background ) {
        el.style.backgroundPosition = `${el.dataset.backgroundPosition}`;
        el.style.backgroundImage = `url( ${el.dataset.background} )`;
      }

      const title = el.querySelector('.c-hero_slide_title');

      new SplitType( title, {
        types: 'lines, word',
        lineClass: 'o-line',
        wordClass: 'o-word',
      });
    } );
  }

  init() {
    this.setupSlides();

    window.setTimeout( () => {
      this.loadSlider();

      gsap.to( this.shortcuts, {
        duration: 1.2,
        delay: 0.6,
        opacity: 1,
        maxWidth: '40rem',
        ease: 'expo.inOut',
        onComplete: () => {
          gsap.to( this.shortcuts.children, {
            //delay: 1.5,
            duration: 1,
            opacity: 1,
          } );
        }
      } );
    }, 1000 );
  }
}
